// router/staticRoutes.js
export const staticRoutes = [
    {
      path: '/login',
      name: 'LoginPage',
      component: () => import('@/views/Login'),
      hidden: true
    },
    {
      path: '/',
      name: 'Layout', // 这个 name 要和 router.addRoute 的第一个参数一致
      component: () => import('@/components/Layout/index'),
      hidden: false,
      redirect: '/dashboard',
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: () => import('@/views/dashboard/index'),
          hidden: false
        },
        {
          path: 'profileSetting',
          name: 'ProfileSetting',
          component: () => import('@/views/userCenter/profileSetting'),
          hidden: false
        },
        {
          path: 'updatePassword',
          name: 'UpdatePassord',
          component: () => import('@/views/userCenter/updatePassord'),
          hidden: false
        }
      ]
    },
    {
      path: '/404',
      name: 'Page404',
      component: () => import('@/views/Page404'),
      hidden: true
    }
  ]